import styled from 'styled-components';

export const SocialIconsSkeletonContainer = styled.div`
  display: flex;
  align-items: center;
`;
